import React, { useState } from 'react';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

const KYCDrawer = ({
  open,
  setOpen,
  data,
  handleUpdate,
  setShowAddNewRule,
  onDelete
}) => {
  const useStyles = makeStyles({
    paperAnchorBottom: {
      borderTopRightRadius: '34px',
      borderTopLeftRadius: '34px'
    }
  });
  const [showMore, setShowMore] = useState(false);
  const classes = useStyles();
  return (
    <div className="w-ful`l">
      <Drawer
        anchor={'bottom'}
        open={open}
        onClose={() => setOpen(false)}
        classes={{ paperAnchorBottom: classes?.paperAnchorBottom }}
      >
        <div className="px-4 w-full font-open-sans pb-3">
          <div className="w-full flex mt-3 items-center">
            <p className="font-open-sans-bold  py-3 text-xl">KYC</p>
            <span className="ml-auto text-base " onClick={() => setOpen(false)}>
              <CloseIcon />
            </span>
          </div>
          <hr className="text-blue-1100 mt-2 mb-1" />
          <div className="grid">
            <p className="font-open-sans-bold capitalize text-lg">
              {data?.breKycname}
              <span
                className="float-right ml-auto cursor-pointer"
                onClick={() => setShowMore(e => !e)}
              >
                <MoreHorizIcon />
                {showMore && (
                  <div className="absolute  bg-white mt-3 px-3 py-2 rounded shadow-md shadow-inner shadow-lg -ml-16 px-4 py-3   items-center font-open-sans text-sm gap-2 grid shadow-xs">
                    <div
                      className="flex gap-2"
                      onClick={() => {
                        handleUpdate(data, true, data?.breKycname);
                        setShowAddNewRule(true);
                        setOpen(false);
                      }}
                    >
                      <EditIcon className="text-base mr-2 cursor-pointer" />
                      <span> Edit</span>
                    </div>
                    <div
                      className="flex gap-2"
                      onClick={() => onDelete(data?.id)}
                    >
                      <DeleteIcon className="text-base cursor-pointer" />
                      <span className="ml-2"> Delete</span>
                    </div>
                  </div>
                )}
              </span>
            </p>
            <p className="text-xs text-grey-2240 font-open-sans text-base">
              {moment(data?.createdAt).format('DD MMM YY')}
            </p>
            <hr className="text-blue-1100 mt-2 mb-1" />
            <p className="font-open-sans-bold text-black-500 text-left mt-2 text-lg">{`${data
              ?.createdBy?.firstName || ''} ${data?.createdBy?.middleName ||
              ''} ${data?.createdBy?.lastName || ''}`}</p>
          </div>

          <div className="bg-ghostWhite w-full mt-4 px-3 py-4 mb-5">
            <p className="text-black-500 font-open-sans-bold text-lg">
              Condition
            </p>
            <p className="text-black-500 font-open-sans text-base capitalize">
              {`${data?.doc1 || ''}`.replace(/_/g, ' ')} Matches
              {` ${data?.doc2 || ' '} `.replace(/_/g, ' ')}
              {data?.percentage || '---'}%
            </p>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default KYCDrawer;
